export default __webpack_public_path__ + "static/char-v-58-527da2a3e16a55605cb1cd87657b4537.png";